import api from "@/lib/api";

const KEY = "gs_consent";
export const CATS = ["preferences", "analytics", "marketing"];
let cfgP = null;
let gaLoaded = false;

export const siteConfig = () => {
  if (!cfgP) cfgP = api.get("/site-config").then((r) => r.data).catch(() => { cfgP = null; return {}; });
  return cfgP;
};

export const getConsent = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };
export const hasConsent = (cat) => !!getConsent()?.cats?.[cat];

const consentId = () => {
  let c = localStorage.getItem("gs_cid");
  if (!c) { c = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem("gs_cid", c); }
  return c;
};

const gtag = (...a) => { window.dataLayer = window.dataLayer || []; window.dataLayer.push(a); };
export const gtagEvent = (name, params = {}) => { if (gaLoaded && window.gtag) window.gtag("event", name, params); };

const dropGaCookies = () => {
  const host = window.location.hostname;
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => /^_ga|^_gid|^_gcl/.test(n)).forEach((n) => {
    [host, `.${host}`, `.${host.split(".").slice(-2).join(".")}`, ""].forEach((d) => {
      document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;${d ? ` domain=${d};` : ""}`;
    });
  });
};

// Google Consent Mode v2 update + load GA4 only after consent
export async function applyConsent(c) {
  const g = (on) => (on ? "granted" : "denied");
  const cats = c?.cats || {};
  (window.gtag || gtag)("consent", "update", {
    analytics_storage: g(cats.analytics), ad_storage: g(cats.marketing), ad_user_data: g(cats.marketing), ad_personalization: g(cats.marketing),
    functionality_storage: g(cats.preferences), personalization_storage: g(cats.preferences), security_storage: "granted",
  });
  if (!cats.analytics && !cats.marketing) { dropGaCookies(); return; }
  const { ga4_id: id } = await siteConfig();
  if (!id || gaLoaded) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
  window.gtag("js", new Date());
  window.gtag("config", id, { cookie_expires: 34128000 });
}

export async function saveConsent(kind, cats) {
  const { policy_version: version = "1.0" } = await siteConfig();
  const c = { kind, cats: Object.fromEntries(CATS.map((k) => [k, !!cats[k]])), version, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  api.post("/consent", { kind, cats: c.cats, version, cid: consentId() }).catch(() => {});
  await applyConsent(c);
  window.dispatchEvent(new Event("gs-consent"));
  return c;
}

export const logImpression = () => siteConfig().then((c) => api.post("/consent", { kind: "impression", version: c.policy_version, cid: consentId() }).catch(() => {}));
export const openCookieSettings = () => window.dispatchEvent(new Event("gs-open-cookies"));

export async function initConsent() {
  const c = getConsent();
  const cfg = await siteConfig();
  if (cfg.gsc_verification && !document.querySelector('meta[name="google-site-verification"]')) {
    const m = document.createElement("meta");
    m.name = "google-site-verification";
    m.content = cfg.gsc_verification;
    document.head.appendChild(m);
  }
  if (c && c.version === (cfg.policy_version || "1.0")) { await applyConsent(c); return true; }
  return false;
}
